import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import ObserversPage from './pages/admin/ObserversPage';
import ObservationsPage from './pages/admin/ObservationsPage';
import ObserverRoomPage from './pages/admin/ObserverRoomPage';
import ObservationDetailPage from './pages/admin/ObservationDetailPage';
import ObservationRegisterPage from './pages/admin/ObservationRegisterPage';
import ClosedActionsPage from './pages/admin/ClosedActionsPage';
import FormFieldsPage from './pages/admin/FormFieldsPage';
import AdminLoginsPage from './pages/admin/AdminLoginsPage';
import AdminLayout from './components/layout/AdminLayout';
import FormPage from './pages/form/FormPage';
import FormSuccessPage from './pages/form/FormSuccessPage';
import HomePage from './pages/form/HomePage';
import CpanelLoginPage from './pages/admin/CpanelLoginPage';
import CpanelPage from './pages/admin/CpanelPage';

function ProtectedRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--text-3)', fontFamily: 'var(--font)' }}>Loading…</div>;
  return admin ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return null;
  return admin ? <Navigate to="/admin" replace /> : children;
}

function SuperadminRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return null;
  return admin?.role === 'superadmin' ? children : <Navigate to="/admin" replace />;
}

function CpanelRoute({ children }) {
  return localStorage.getItem('hse_cpanel_token') ? children : <Navigate to="/cpanel/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontFamily: 'var(--font)', fontSize: '0.85rem', borderRadius: '6px', boxShadow: 'var(--shadow-lg)' },
            duration: 3500,
          }}
        />
        <Routes>
          {/* Public form routes */}
          <Route path="/submit/:slug" element={<HomePage />} />
          <Route path="/submit/:slug/form" element={<FormPage />} />
          <Route path="/submit/:slug/success" element={<FormSuccessPage />} />
          <Route path="/home" element={<HomePage />} />

          {/* Auth routes */}
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/cpanel/login" element={<CpanelLoginPage />} />
          <Route path="/cpanel" element={<CpanelRoute><CpanelPage /></CpanelRoute>} />

          {/* Admin routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="observations" element={<ObservationsPage />} />
            <Route path="observations/observer/:observerId" element={<ObserverRoomPage />} />
            <Route path="observations/:id" element={<ObservationDetailPage />} />
            <Route path="register" element={<ObservationRegisterPage />} />
            <Route path="closed-actions" element={<ClosedActionsPage />} />
            <Route path="observers" element={<ObserversPage />} />
            <Route path="form-fields" element={<FormFieldsPage />} />
            <Route path="admin-logins" element={<SuperadminRoute><AdminLoginsPage /></SuperadminRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
